module.exports = __webpack_public_path__ + "static/img/serve2.6fd0577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IncentiveTravel/serve2.png
// module id = FpVR
// module chunks = 1